module.exports = __webpack_public_path__ + "img/s-24.40068455.jpg";